const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  debug: process.env.REACT_APP_DEBUG === 'true',
  siteTitle: process.env.REACT_APP_SITE_TITLE || 'MMOSolution Mail Box'
}

export default config;